import { CLIENT_VERSION } from './const'

import { ModuleID } from '../types'
import { IClientModule } from './types'

import sendResponse from './requests/sendResponse'
import loadAction from './requests/loadAction'
import requestSurveyModeChange from './requests/requestSurveyModeChange'
import requestJumpToQuestion from './requests/requestJumpToQuestion'
import requestChangeQuota from './requests/requestChangeQuota'
import requestSetLocale from './requests/requestSetLocale'
import requestPrevAction from './requests/requestPrevAction'
import requestExitAction from './requests/requestExitAction'
import sendFile from './requests/sendFile'

let moduleLoaded = false
let clientToken: string = null
let dataValues: unknown = null
let locale: string = null
const ClientModule: IClientModule = {
  get id() {
    return ModuleID.CLIENT
  },
  config({ token } = {}) {
    if (null != token) clientToken = token
    return ClientModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(ClientModule)
  },
  get loaded() {
    return moduleLoaded
  },
  get token() {
    return clientToken
  },
  get data_values() {
    return dataValues
  },
  set data_values(values: unknown) {
    dataValues = values
  },
  get locale() {
    return locale
  },
  set locale(value: string) {
    locale = value
  },
  get version() {
    return CLIENT_VERSION
  },
  sendResponse,
  loadAction,
  requestSurveyModeChange,
  requestJumpToQuestion,
  requestChangeQuota,
  requestSetLocale,
  requestPrevAction,
  requestExitAction,
  sendFile
}

export default ClientModule
